import React from 'react';
import { Grid, ListSubheader, Typography } from '@mui/material';
import ImageItem from './ImageItem';
import { showOverlay } from '../../../utils/showOverlay';
import { useSelector } from 'react-redux';
import buildImagePreviews from '../../../utils/buildImagePreviews';
import NoImagesDialog from './NoImagesDialog';
import DownloadBaselineUploaderDialog from './DownloadBaselineUploaderDialog';
import Clear from '../ActionBar/Clear';

const ShowImagePreviews = ({ imageListPreviews }) => {
  // if imageListPreviews is an empty object, show the NoImagesDialog and DownloadBaselineUploaderDialog
  // otherwise, show the image previews
  return Object.keys(imageListPreviews).length ? (
    <div>
      <span style={clear}>
        <Clear />
      </span>
      {Object.keys(imageListPreviews).map((image, index) => (
        <React.Fragment key={index}>
          <ListSubheader sx={header}>
            <Typography variant="h6" sx={{ fontWeight: 300 }}>
              {image}
            </Typography>
          </ListSubheader>
          <Grid container padding={2} spacing={{ xs: 1, md: 1 }} columns={12}>
            {imageListPreviews[image].map((imageItem, index) => (
              <Grid item sm={12} md={4} lg={3} xl={2} key={index}>
                <ImageItem imageItem={imageItem} />
              </Grid>
            ))}
          </Grid>
        </React.Fragment>
      ))}
    </div>
  ) : (
    <div>
      <DownloadBaselineUploaderDialog />
      <NoImagesDialog />
    </div>
  );
};

export default function ImagePreviews() {
  /**
   * Display a list of image previews
   *
   * @param {None} None
   * @returns {JSX.Element}
   *
   * @example
   * return (
   *  <ImagePreviews />
   * )
   */

  // pull imageList and isLoading from the images slice of state
  const { imageList, isLoading } = useSelector((state) => state.images);

  // build imageListPreviews from imageList
  const imageListPreviews = buildImagePreviews(imageList);

  // if Redux has not completed its api calls for imageList, show the loading overlay
  return isLoading == false ? (
    <div style={container} id="imagePreviews">
      <ShowImagePreviews imageListPreviews={imageListPreviews} />
    </div>
  ) : (
    showOverlay(isLoading)
  );
}

const container = {
  gridColumn: '2 / -1',
  overflowY: 'scroll',
  background: '#121212',
};

const header = {
  background: '#121212',
  height: '62px',
  display: 'flex',
  alignItems: 'center',
};

const clear = { color: 'white', position: 'absolute', right: '60px', top: '135px' };
